export const getIntervalLabel = (interval: string) => {
  switch (interval) {
    case '1D':
      return '1 Day change';
    case '1W':
      return '7 day change';
    case '1M':
      return '1 month change';
    default:
      return '';
  }
};

export type MarketType = 'demand' | 'prediction-markets';
